import { render, staticRenderFns } from "./SemDadosDashboard.vue?vue&type=template&id=38b006c6"
import script from "./SemDadosDashboard.vue?vue&type=script&lang=js"
export * from "./SemDadosDashboard.vue?vue&type=script&lang=js"
import style0 from "./SemDadosDashboard.vue?vue&type=style&index=0&id=38b006c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports